<template>
  <pt-roles-form class="pt-roles-form__page" :is-edit="is_edit" :id="id"></pt-roles-form>
</template>

<script>
import PtRolesForm from 'cps/customer-manage/pt-user-roles/pt-roles-form'
export default {
  name: 'pt-roles-form__view',
  components: {
    'pt-roles-form': PtRolesForm
  },
  props: {
    isEdit: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  },
  created () {
    console.log('isEdit', this.isEdit)
  }
}
</script>
